import { RootState } from 'src/store/store';
import { connect } from 'react-redux';
import Footer from './Footer';


const mapStateToProps = (state: RootState) => ({
    accessibleTools: state.Init.initData.associateDetails.accessibleTools,

});

const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps) (Footer);